import { supabase } from '../../lib/supabase'
import { activeTenant } from '../../lib/tenant'

type Slot = { slot_date: string; slot_time: string }

export function bindAppointmentAvailability(
  form: HTMLFormElement,
  projectId: () => string | null,
  onError?: (message: string) => void,
) {
  const dates = form.elements.namedItem('requested_date') as HTMLSelectElement
  const times = form.elements.namedItem('requested_time') as HTMLSelectElement
  let slots: Slot[] = []
  let request = 0
  let disposed = false
  const option = (value: string, label: string) => new Option(label, value)
  const updateTimes = () => {
    times.replaceChildren(option('', dates.value ? 'Selecciona una hora' : 'Selecciona una fecha'))
    for (const time of [...new Set(slots.filter(slot => slot.slot_date === dates.value).map(slot => slot.slot_time.slice(0, 5)))]) {
      times.add(option(time, time))
    }
  }
  const refresh = async () => {
    const current = ++request
    const oldDate = dates.value
    dates.replaceChildren(option('', 'Cargando horarios…'))
    times.replaceChildren(option('', 'Selecciona una fecha'))
    try {
      if (!supabase) throw new Error('No se pudo consultar la disponibilidad.')
      const { data, error } = await supabase.rpc('get_public_appointment_slots', {
        p_company_id: activeTenant.companyId,
        p_project_id: projectId(),
      })
      if (error) throw error
      if (disposed || current !== request) return
      slots = (data || []) as Slot[]
      dates.replaceChildren(option('', slots.length ? 'Selecciona una fecha' : 'No hay horarios publicados'))
      for (const day of [...new Set(slots.map(slot => slot.slot_date))]) {
        dates.add(option(day, new Date(day + 'T12:00:00').toLocaleDateString('es-DO', { day: 'numeric', month: 'long', year: 'numeric' })))
      }
      if ([...dates.options].some(item => item.value === oldDate)) dates.value = oldDate
      updateTimes()
    } catch (error) {
      if (disposed || current !== request) return
      slots = []
      dates.replaceChildren(option('', 'No se pudo cargar la disponibilidad'))
      times.replaceChildren(option('', 'Selecciona una fecha'))
      onError?.(error instanceof Error ? error.message : 'No se pudo cargar la disponibilidad.')
    }
  }
  dates.addEventListener('change', updateTimes)
  return {
    refresh,
    dispose: () => { disposed = true; ++request; dates.removeEventListener('change', updateTimes) },
  }
}
